function mtnValidate(phone) {
    // Remove any non-digit characters
    phone = phone.replace(/\D/g, "");
    // Normalize to international format
    if (phone.startsWith("0")) {
        phone = "249" + phone.substring(1);
    } else if (phone.startsWith("9")) {
        phone = "249" + phone;
    }

    // Validate MTN Sudan prefixes
    const regex = /^249(?:92|93|99)\d{7}$/;

    if (!regex.test(phone)) {
        return {
            valid: false,
            phone: null,
            message: "رقم الهاتف غير صحيح أو لا يتبع لشبكة MTN السودان.",
        };
    }

    return {
        valid: true,
        phone,
        message: "رقم الهاتف صحيح.",
    };
}

export { mtnValidate };